import { useEffect } from "react";
import {
  getRegionFromPath,
  getRegionFromSession,
  setRegionPreference,
} from "@/utils/region";
import { isIndiaCountry, resolveGeoCountryFromClient } from "@/utils/resolveGeoCountry";

const GEO_HOME_PATHS = new Set(["/", "/in", "/holiday", "/in/holiday"]);

/**
 * Auto country switch only when this tab has no region-locked session.
 * Once session exists, the URL country wins and is not rewritten.
 */
export default function RegionRedirect() {
  useEffect(() => {
    const path = window.location.pathname;
    const search = window.location.search;

    if (search.includes("countryswitch=true")) return;

    const urlRegion = getRegionFromPath(path);

    if (getRegionFromSession()) {
      setRegionPreference(urlRegion);
      return;
    }

    if (!GEO_HOME_PATHS.has(path)) {
      setRegionPreference(urlRegion);
      return;
    }

    let cancelled = false;

    (async () => {
      const geoCountry = await resolveGeoCountryFromClient();
      if (cancelled || getRegionFromSession()) return;

      if (!geoCountry) {
        if (path !== "/" && path !== "/in") {
          setRegionPreference(urlRegion);
        }
        return;
      }

      const geoRegion = isIndiaCountry(geoCountry) ? "IN" : "AE";
      setRegionPreference(geoRegion);

      const target = geoRegion === "IN" ? "/in/holiday" : "/holiday";
      if (urlRegion !== geoRegion) {
        window.location.replace(target);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
